import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { getBongoUrl } from '../../../common/utils/bongo';

type SegmentCustomPropertyStatistics = {
  name: string;
  lastOccurrence: Date;
  occurrenceRatio: number;
  types: string[];
};

function useSegmentIntrospectSchema(tenant: number) {
  return useQuery<SegmentCustomPropertyStatistics[]>(
    ['segment-introspect-schema', tenant],
    async () => {
      const { data: schema } = await axios.get<
        SegmentCustomPropertyStatistics[]
      >(`${getBongoUrl()}/v1/org/${tenant}/integrations/segment/introspect-schema`);
      return schema;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );
}

export default useSegmentIntrospectSchema;
